// export const API = 'https://sts-yyhy.onrender.com';
export const API =  'http://localhost:5000';
export const url = 'http://localhost:3000/login';